import { zusWarningKhNoEmployees, zusWarningNoFormOfAccounting } from './route-name/zus-warning.js';

export default [
  {
    path: '/zus-warning-kh-no-employees',
    name: zusWarningKhNoEmployees,
    components: {
      default: () => import('../views/pages/zus-warning/zus-warning-kh-no-employees-view'),
    },
    meta: {
      breadcrumb: [
        { title: 'ZUS', url: '/zus-packages' },
      ],
      rule: 'editor',
    },
  },
  {
    path: '/zus-warning-no-form-of-accounting',
    name: zusWarningNoFormOfAccounting,
    components: {
      default: () => import('../views/pages/zus-warning/zus-warning-no-form-of-accounting-view.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'ZUS', url: '/zus-packages' },
      ],
      rule: 'editor',
    },
  },
];
